angular.module("mobilezuz").factory("GMap", ["GoogleMapService", "GgMapMobileService", factory]);

function factory(GoogleMapService, GgMapMobileService) {
  var curGgMapSrv = window.cordova ? GgMapMobileService : GoogleMapService

  return curGgMapSrv;
}
